module.exports = __webpack_public_path__ + "img/album23_13.17307460.jpg";